import { PlantsEnum, SubPlantCodesEnum } from "@gtpl/shared-models/common-models";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { GrnItemDefects } from "./grn-item-defects.entity";
import { Grn } from "./raw-material-grn.entity";
@Entity('grn_items')
export class GrnItems {

    @PrimaryGeneratedColumn("increment", { name: 'grn_item_id' })
    grnItemId: number;
    @Column({
        type: 'int',
        nullable: true,
        // default: 0,
        name: 'grn_id'
    })
    grnId: number;

    // @Column({
    //     type: 'int',
    //     nullable: true,
    //     // default: 0,
    //     name: 'plant_id'
    // })
    // plantId: number;

    // @Column({
    //     type: 'int',
    //     nullable: true,
    //     // default: 0,
    //     name: 'sub_plant_id'
    // })
    // subPlantId: number;
    @Column("int", {
        nullable: false,
        name: "indent_id"
    })
    indentId: number;
    @Column("int", {
        nullable: false,
        name: "indent_item_id"
    })
    indentItemId: number;
    @Column("varchar", {
        nullable: true,
        length: 30,
        name: "lot_number"
    })
    lotNumber: string;
    @Column("int", {
        nullable: true,
        name: "sale_order_id"
    })
    saleOrderId: number;
    @Column("int", {
        nullable: true,
        name: "sale_order_item_id"
    })
    saleOrderItemId: number;
    @Column("int", {
        nullable: false,
        name: "farmer"
    })
    farmer: number;
    @Column("int", {
        nullable: false,
        name: "farmer_code"
    })
    farmerCode: number;
    @Column("int", {
        nullable: true,
        name: "quantity"
    })
    quantity: number;
    @Column("int", {
        nullable: true,
        name: "count"
    })
    count: number;

    @Column("int", {
        nullable: true,
        name: "actual_quantity"
    })
    actualQuantity: number;
    @Column("int", {
        nullable: true,
        name: "actual_count"
    })
    actualCount: number;
    @Column("int", {
        nullable: false,
        name: "product"
    })
    product: number;
    @Column("int", {
        nullable: true,
        name: "broker",
        default: 0,
    })
    broker: number;
    @Column("int", {
        nullable: true,
        name: "price"
    })
    price: number;
    @Column("int", {
        nullable: true,
        name: "received_boxes"
    })
    receivedBoxes: number;

    @Column("int", {
        nullable: true,
        name: "soft_percentage"
    })
    softPercentage: number;
    @Column("int", {
        nullable: true,
        name: "boxes"
    })
    boxes: number;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @Column("boolean", {
        nullable: false,
        default: false,
        name: "vi_inspection"
    })
    isVInspectionCompleted: boolean;

    @Column("boolean", {
        nullable: false,
        default: false,
        name: "rm_inspection"
    })
    isRmInspectionCompleted: boolean;

    @Column("boolean", {
        nullable: false,
        default: false,
        name: "antibiotic_test"
    })
    isAntibioticsTestCompleted: boolean;

    @Column("boolean", {
        nullable: false,
        default: false,
        name: "assign_to_rm"
    })
    assignToRm: boolean;

    @Column("varchar", {
        nullable: true,
        name: "loose_shell"
    })
    looseShell: string;

    @Column("int", {
        nullable: true,
        name: "fungus_percentage"
    })
    fungusPercentage: number;
    
    @Column("varchar", {
        nullable: true,
        name: "remarks"
    })
    remarks: string;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
    @Column("int", {
        nullable: false,
        name: "ref_no"
    })
    monthlyRefNo: number;
    @ManyToOne(type => Grn, grn => grn.grnItemsInfo, { nullable: false, })
    @JoinColumn({ name: "grn_id" })
    grnInfo: Grn;

    @OneToMany(type => GrnItemDefects, grnItemDefects => grnItemDefects.grnItemsInfo, { cascade: true })
    grnItemDefects: GrnItemDefects[];



}
